import React, { useEffect, useContext, FunctionComponent } from "react";
import Header from "./header";
import Footer from "./footer";
import Snowfall from 'react-snowfall'
import { useLocation, useRouteMatch } from "react-router-dom";
import { UserContext } from "./UserContext";
import withAnalytics from "../components/AnalyticsWrapper";
import classNames from "classnames";
import useWindowSize from "react-use/lib/useWindowSize";

// we use FunctionComponent type here to gain type-safe access to children
const Layout: FunctionComponent = props => {
  const { user } = useContext(UserContext);
  let loc = useLocation();
  let isGameLobby = useRouteMatch("/game/:id");
  let isGamePlay = useRouteMatch("/play/:id");
  let isGameResults = useRouteMatch("/result/:id");
  const showHeader = loc.pathname !== "/";

  const { width, height } = useWindowSize();

  return (
    /* put html and css that will wrap entire app here */
    <main
      role="main"
      className={classNames({
        "landing-page-ctr": !showHeader,
        "game-lobby-ctr": isGameLobby,
        "game-play-ctr": isGamePlay,
        "game-results-ctr": isGameResults,
        "hide-header": !showHeader
      })}
    >
      <div className={classNames({"hide-snow": isGamePlay || isGameResults})}>
        <Snowfall snowflakeCount={150} />
      </div>
      <div className="outer-container" style={{ minHeight: `${height}px` }}>
        {props.children}
        {showHeader && <Header />}
      </div>
      <Footer />
    </main>
  );
};

export default withAnalytics(Layout);
